export default __webpack_public_path__ + "static/media/image2-section-1.3423ad42.svg";